import React from "react";
import moment from "moment";

export const checkDateBeforeNow = (dateCheck) => {
  if (!dateCheck) {
    return null;
  }
  let now = moment();
  let isBefore = moment(dateCheck).diff(now);
  if (isBefore < 0) {
    return true;
  }
  return false;
};

export function calculateDate(dateTime, t) {
  let now = moment();
  let dateCheck = moment(dateTime);
  let minutes = now.diff(dateCheck, "minutes");
  if (minutes < 60) {
    return `${minutes} ${t("mins ago")}`;
  }
  let hours = now.diff(dateCheck, "hours");
  if (hours < 24) {
    return `${hours} ${t("hours ago")}`;
  }
  let days = now.diff(dateCheck, "days");
  if (days < 7) {
    return `${days} ${t("days ago")}`;
  }
  let weeks = now.diff(dateCheck, "weeks");
  if (weeks < 5) {
    return `${weeks} ${t("weeks ago")}`;
  }
  let mounths = now.diff(dateCheck, "months");
  if (mounths < 30) {
    return `${mounths} ${t("mounths ago")}`;
  }
  let years = now.diff(dateCheck, "years");
  return `${years} ${t("years ago")}`;
}

export function lastCheckIn(CheckIn1, CheckIn2) {
  let lastCheckIn = moment(CheckIn1).min(CheckIn2).format();
  return lastCheckIn;
}